import { FEATURE_PERMISSIONS } from 'src/types/enum';

import usePermission from './usePermission';
import useSubscriptionPlan from './useSubscriptionPlan';

export const useCanUseWorkflows = (): boolean => {
  const hasWorkflowsPermission = usePermission(FEATURE_PERMISSIONS.WORKFLOWS);
  const { isTrialPlan } = useSubscriptionPlan();

  return hasWorkflowsPermission && !isTrialPlan;
};

export default useCanUseWorkflows;
